<script setup lang="ts">
import { TVulnerabilityProofOfConcept, TVulnerabilitySeverity } from '../../models/types';

const props = defineProps<{
  proofOfConcepts: TVulnerabilityProofOfConcept[];
  severity: TVulnerabilitySeverity;
}>();

function getSeverityColorClass(severity: TVulnerabilitySeverity): string {
  if (severity === 'low') return 'tw:bg-vuln-low';
  if (severity === 'medium') return 'tw:bg-vuln-medium';
  return 'tw:bg-vuln-high';
}
</script>

<template>
  <div class="tw:flex tw:flex-col tw:gap-3">
    <div v-for="(item, index) in proofOfConcepts" :key="index" class="tw:flex tw:flex-col tw:gap-1">
      <div>
        <div
          v-for="(codeBlock, codeIndex) in item.code"
          :key="codeIndex"
          class="tw:flex tw:flex-col tw:gap-1"
        >
          <div
            v-for="(line, lineIndex) in codeBlock.lines"
            :key="lineIndex"
            class="tw:flex tw:overflow-auto tw:[&::-webkit-scrollbar]:hidden"
          >
            <div
              class="tw:block tw:border-2 tw:border-transparent tw:shrink-0"
              :class="getSeverityColorClass(severity)"
            />
            <pre
              v-highlightjs="line.content"
              class="tw:m-0 tw:bg-general tw:pl-10 tw:flex-1 tw:mb-0!"
            ><code class="bash tw:p-0! tw:text-sm! tw:leading-6! tw:text-shadow-none! tw:text-main!"></code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// TODO: replace with a proper local font import
@import url('https://fonts.googleapis.com/css2?family=Inconsolata&display=swap');

pre {
  font-family: 'Inconsolata', monospace;
}
</style>
